import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Avatar, Menu, Dropdown } from 'antd';
import {
  DownOutlined
} from '@ant-design/icons';
import FAIcon from 'components/util-components/FAIcon';
import { faBuilding } from '@fortawesome/pro-light-svg-icons'
import { useSelector } from 'react-redux';

export const NavAccounts = ({ theme }) => {


  const history = useHistory()
  const currentTheme = theme.currentTheme;
  const currentAccount = useSelector(s => s.account?.details);
    
  const AccountLogo = () => {

    if (!currentAccount?.favicon) {
      return (<FAIcon icon={faBuilding} className="anticon" />)
    } else { 
      return (<img style={{ maxHeight: '20px' }} src={currentAccount?.favicon} alt={currentAccount?.name} />)  
      /*
            if(currentTheme === 'light') {
                // theme is light so use dark logo
                let logo = currentAccount?.dark_logo ? currentAccount?.dark_logo : currentAccount?.light_logo
                return (<img style={{ maxHeight: '40px' }} src={logo} alt={currentAccount?.name} />)
            } else {
                // theme is dark so use light logo
                let logo = currentAccount?.light_logo ? currentAccount?.light_logo : currentAccount?.dark_logo
                return (<img style={{ maxHeight: '40px' }} src={logo} alt={currentAccount?.name} />)
            } 
            */
    }  
  }

  const AccountLabel = () => {

    // Only one account  
    return (
      <>
        <span className="d-flex justify-content-between align-items-center" >
          <div style={{ height: '70px', lineHeight: '70px' }}>
            <AccountLogo />
            <span className="ml-2" style={{ fontWeight: 500 }}>{currentAccount?.name}</span>
          </div>
        </span>
      </>
    )

    // Multiple Accounts
    /*
        const menu = (
            <Menu>
                <Menu.Item key={"1"}>
                    <span className="d-flex justify-content-between align-items-center">
                        <div>
                            <img style={{ maxWidth: '40px' }} src={`https://logopond.com/logos/d5980f6bf1cc10fd6ff22363cc8a697a.png`} alt={'ys'} />
                            <span className="ml-2">Account Name 1</span>
                        </div>
                    </span>
                </Menu.Item>
                <Menu.Item key={"2"}>
                    <span className="d-flex justify-content-between align-items-center">
                        <div>
                            <img style={{ maxWidth: '40px' }} src={`https://logopond.com/logos/d5980f6bf1cc10fd6ff22363cc8a697a.png`} alt={'ys'} />
                            <span className="ml-2">Account Name 2</span>
                        </div>
                    </span>
                </Menu.Item>
            </Menu>
        ); 

        return (
            <Menu mode="horizontal"  >
                <Menu.Item key="0" style={{ cursor: 'auto' }} className="app-header-top-nav-menu-item">
                    <Dropdown overlay={menu}> 
                        <span className="d-flex justify-content-between align-items-center">
                            <div>
                                <img style={{ maxWidth: '40px' }} src={`https://logopond.com/logos/d5980f6bf1cc10fd6ff22363cc8a697a.png`} alt={'ys'} />
                                <span className="ml-2">{currentAccount?.name} <DownOutlined /></span>
                            </div>
                        </span>
                    </Dropdown>
                </Menu.Item>
            </Menu>
        );
        */

  }

  return (
    <AccountLabel />
  );
}


const mapStateToProps = ({ theme }) => {
  return { theme }
};

export default connect(mapStateToProps)(NavAccounts);

